const paymentEndpoints = {
  accessToken: (iframeflag, customerNumber) => { 
    const stat = 70007;
    const currTimestamp = Date.now(); //1482905176396
    const utcDateString = (new Date(currTimestamp)).toUTCString(); 
    const timestamp = new Date(utcDateString).getTime();	
    const converted_expiry_time = (timestamp*stat)-2313289564;
    return `/paymetricaccesstoken?iframeflag=${iframeflag}&customerNumber=${customerNumber}&stat=${converted_expiry_time}`  
  },
  paymentToken: (accesstoken,customerNumber,amount="0.00",zipcode) => `/paymetricresponsepacket?accessToken=${accesstoken}&customerNumber=${customerNumber}&Amount=${amount}&zipcode=${zipcode}`
};

export default paymentEndpoints;